import React from 'react';
import { Form } from 'react-bootstrap';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import type { LayerDef } from 'hooks/Meteorology/Agro/Maps/useAgroMapState';

import './index.scss';

export interface LayersSheetProps {
  open: boolean;
  dismiss: () => void;
  layers: Record<string, boolean>;
  onToggle: (key: string) => () => void;
  definitions: LayerDef[];
}

export default function LayersSheet({
  open,
  dismiss,
  layers,
  onToggle,
  definitions,
}: LayersSheetProps) {
  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Camadas"
      className="agro-wbs-maps-layers-sheet"
    >
      <div className="agro-wbs-maps-layers-list">
        {definitions.map(({ key, label }) => (
          <Form.Check
            key={key}
            type="switch"
            id={`agro-wbs-maps-layer-${key}`}
            label={label}
            className="agro-wbs-maps-layer-row"
            checked={layers[key] ?? true}
            onChange={onToggle(key)}
          />
        ))}
      </div>
    </BottomSheet>
  );
}
